//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/Expression.js";
let d=[[[0,"CamCurveType",1,0],[0,"CreateXYAxis",1,0],[0,"DocumentPartType",1,0],[0,"Name",1,0],[0,"Point",1,"Point",0],[1,"RadialCurveBaseRadius",0,"Expression",0],[0,"ShowAxisScale",1,0],[0,"ShowPoints",1,0],[0,"ShowSegmentData",1,0],[0,"XAxisLabel",1,0],[0,"YAxisLabel",1,0]],[[["parts"],"AddSelectedParts",{},1,0],[["pos","objectTag"],"InsertRow",{},2,0],[["index"],"DeleteRow",{},1,0],[["index","state"],"SetRowState",{},2,0],[["index"],"GetRowState",{R_:{state:''}},1,0],[["index","color"],"SetRowColor",{},2,0],[["index"],"GetRowColor",{R_:{color:"NXColor"}},1,0]],[]];
SPLM.Mechatronics.CamProfileDocumentationBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.CamProfileDocumentationBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.CamProfileDocumentationBuilder.CurveTypes = Object.freeze({
    "Standard2D" : "Standard2D", "Radial2D" : "Radial2D", "Radial3D" : "Radial3D"});

SPLM.Mechatronics.CamProfileDocumentationBuilder.PartTypes = Object.freeze({
    "WorkPart" : "WorkPart", "NewAssembly" : "NewAssembly"});

export default SPLM;